import ListTechnologies from "./components/list";
export default function Technologies(){
    return <ListTechnologies/>
};